export interface IStatusResponse {
    Health: string;
}

export interface IUpgradeResponse {
    upgrade : boolean;
}